export const useCheckEmail = (email: string) => {
  const regExp = /[a-zA-Z0-9._+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9.]+/g
  return regExp.test(email)
}
